<template>
  <div class="py-md-5 py-4">
    <div class="text-center mb-5">
      <h3>Reset Password</h3>
      <p class="text-muted">Reset Password with Doot.</p>
    </div>

    <form>
      <div class="mb-4">
        <label class="form-label">New Passwoed</label>
        <div class="position-relative auth-pass-inputgroup mb-3">
          <input
            type="password"
            class="form-control pe-5"
            placeholder="Enter Password"
            id="password"
            v-model="password"
            required
          />
          <button
            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
            type="button"
            @click="$store.state.utils.switTypeInput"
          >
            <i class="ri-eye-fill align-middle"></i>
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label for="replaypassword" class="form-label">Replay Password</label>
        <input
          type="password"
          class="form-control"
          id="replaypassword"
          v-model="replaypassword"
        />
      </div>
      <div class="form-group">
        <ul id="passwordHelp" class="form-text text-muted">
          <li :class="has_lowercsae ? 'has_required' : ''">
            one lowercase letter
          </li>
          <li :class="has_uppercase ? 'has_required' : ''">
            one uppercase letter
          </li>
          <li :class="has_number ? 'has_required' : ''">One number</li>
          <li :class="has_special ? 'has_required' : ''">
            one special character.
          </li>
          <li :class="has_minimum_lenth ? 'has_required' : ''">
            atleast 8 chacters
          </li>
        </ul>
      </div>
      <div class="text-center mt-4">
        <button
          v-if="passwordIsCorrect && password === replaypassword"
          type="submit"
          class="btn btn-primary w-100"
          @click="resetpassword"
        >
          Reset
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-primary w-100 disabled"
          disabled
        >
          Reset
        </button>
      </div>
    </form>
    <!-- end form -->

    <div class="mt-5 text-center text-muted">
      <p>
        Remember It ?
        <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
          <a
            role="link"
            @click="navigate"
            class="fw-medium text-decoration-underline"
            @keypress.enter="navigate"
          >
            Login
          </a>
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",

  data() {
    return {
      password: "",
      replaypassword: "",

      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,

      passwordIsCorrect: false,
    };
  },

  watch: {
    password() {
      const val = this.$store.state.utils.filters.password(this.password);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.modules.api
        .validatTokenOfReset(this.$route.params.token)
        .then((resp) => {
          if (resp.status != 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "The link has already been used",
              },
              2500
            );
            this.$router.push({ name: "Home" });
          }
        });
    });
  },

  methods: {
    resetpassword() {
      event.preventDefault();

      const data = {
        password: this.password,
      };

      this.$store.state.modules.api
        .resetpassword(data, this.$route.params.token)
        .then((resp) => {
          this.password = "";
          this.replaypassword = "";
          if (resp.status == 200) {
            this.$router.push({ path: "/profile" });
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "Password denied Please enter a different unit",
              },
              2500
            );
          }
        });
    },
  },
};
</script>
